import moment from 'moment';
import { SEC_PER_HR, SIXTY_MINUTES, HUNDRED, SECONDS_TO_MINUTES } from 'appConstants';

export const convertToPercentString = (ratio, t) => {
  if (isNaN(ratio)) {
    return t('n_a', 'N/A');
  }

  if (!isFinite(ratio)) {
    return `0%`;
  }

  return `${Math.round(HUNDRED * ratio)}%`;
};

export const generateTimeString = (timeInSeconds, t) => {
  let timeString = t('n_a', 'N/A');
  const d = moment.duration(timeInSeconds, 'seconds');
  if (timeInSeconds > 0) {
    timeString = `${timeInSeconds} ${t('sec', 'sec')}`;
  }
  const hours = Math.floor(d.asHours());
  const mins = Math.ceil(d.asMinutes()) - hours * SIXTY_MINUTES;
  if (timeInSeconds > SECONDS_TO_MINUTES) {
    timeString = `${mins} ${t('min', 'min')}`;
  }

  if (timeInSeconds > SEC_PER_HR) {
    timeString = `${hours} ${t('hrs', 'hrs')}`;
  }

  return timeString;
};

export const generateTimeWithSeconds = (timeInSeconds) => {
  let timeString = 'N/A';
  if (timeInSeconds > 0) {
    timeString = `${Math.round(timeInSeconds)} sec`;
  }
  if (timeInSeconds > SIXTY_MINUTES) {
    timeString = `${Math.round(timeInSeconds / SIXTY_MINUTES)} min ${
      Math.round(timeInSeconds) % SIXTY_MINUTES
    } sec`;
  }
  if (timeInSeconds > SEC_PER_HR) {
    timeString = `${Math.round(timeInSeconds / SEC_PER_HR)} hrs ${
      Math.round(timeInSeconds / SIXTY_MINUTES) % SIXTY_MINUTES
    } min`;
  }

  timeString = timeString.replace(/ 0 (sec|min)$/g, '');

  return timeString;
};

const extractUnreadMessagesCountFromTitle = (title) => {
  // Regular expression to match the number in parentheses
  const match = /\((\d+)\)/.exec(title);
  return match ? match[1] : null;
};

export const updateUnreadMessagesCountInDocumentTitle = (unreadMessages) => {
  const { title } = document;
  const currentUnreadMessages = extractUnreadMessagesCountFromTitle(title);
  if (unreadMessages === 0) {
    document.title = title.replace(`(${currentUnreadMessages})`, '').trim();
  } else {
    document.title = currentUnreadMessages
      ? title.replace(`(${currentUnreadMessages})`, `(${unreadMessages})`)
      : `(${unreadMessages}) ${title}`;
  }
};

export const updateDocumentTitleWithComponentName = (componentName) => {
  const unreadMessagesCount = extractUnreadMessagesCountFromTitle(document.title);
  if (unreadMessagesCount) {
    //	Example: (10) Dashboard - TextEngagement Web-App
    document.title = `(${unreadMessagesCount}) ${componentName}`;
  } else {
    document.title = `${componentName}`;
  }
};

export const dateFormatter = (date, onlyMonthDayFormat) => {
  const dateNow = new Date(date);
  const monthWithOffset = dateNow.getUTCMonth() + 1;
  const month = monthWithOffset.toString().length < 2 ? `0${monthWithOffset}` : monthWithOffset;
  const day =
    dateNow.getUTCDate().toString().length < 2 ? `0${dateNow.getUTCDate()}` : dateNow.getUTCDate();

  if (!onlyMonthDayFormat) {
    const year = dateNow.getFullYear();
    return `${month}/${day}/${year}`;
  }

  return `${month}/${day}`;
};
